var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMutualIcPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "14xa42p14a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qjn61jkwkb",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004CC4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#14xa42p14a)",
    d: "M5.1 18C2.05 18 0 15.86 0 12.676V5.325C0 2.14 2.05 0 5.1 0h7.8C15.95 0 18 2.14 18 5.325v7.35C18 15.862 15.95 18 12.9 18H5.1z",
    transform: "translate(-298 -137) translate(282 129) translate(9 8) translate(7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#qjn61jkwkb)",
    d: "M11.532 9.67c.201-.266.947-1.096 1.91-.505.615.372 1.132.876 1.685 1.415.211.206.362.441.462.692.301.76.145 1.671-.178 2.423-.382.895-1.113 1.57-2.034 1.866-.41.132-.838.189-1.266.189H4.526c-.755 0-1.423-.177-1.97-.509-.343-.208-.404-.687-.15-.999.426-.52.846-1.042 1.27-1.568.806-1.007 1.35-1.299 1.955-1.042.245.105.491.265.745.433.675.45 1.613 1.069 2.85.398.85-.47 1.342-1.274 1.77-1.97.176-.284.343-.567.536-.824zM5.497 3.374c1.24 0 2.25 1.018 2.25 2.268 0 1.25-1.01 2.266-2.25 2.266S3.248 6.892 3.248 5.643c0-1.25 1.009-2.268 2.25-2.268z",
    transform: "translate(-298 -137) translate(282 129) translate(9 8) translate(7)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutualIcPhoto);
export default __webpack_public_path__ + "static/media/mutual-ic-photo.1f45fbd5.svg";
export { ForwardRef as ReactComponent };